import React from 'react';

import SOURCES from 'ub/ui/asset-library/asset-sources';
import { assetSourcePropType } from './prop-types';

import styles from './source-tab.scss';
import unsplashIcon from 'ub/icons/asset-library/unsplash.svg';

const ICONS = {
  unsplash: unsplashIcon,
};

export default function SourceTab({ source, totalItems }) {
  const icon = ICONS[source];
  const { label, isExternal } = SOURCES[source];

  return (
    <div className={styles.wrapper}>
      {icon && (
        <div
          className={styles.icon}
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={icon ? { __html: icon } : undefined}
        />
      )}

      {label}

      {!isExternal && typeof totalItems === 'number' ? ` (${totalItems})` : null}
    </div>
  );
}

SourceTab.propTypes = {
  source: assetSourcePropType.isRequired,
  totalItems: React.PropTypes.number,
};



// WEBPACK FOOTER //
// ./src/components/asset-library/source-tab.jsx